export default __webpack_public_path__ + "static/media/ico-thumbnail-black.14ed6cec.svg";